
import {Component, Prop, Vue} from "vue-property-decorator";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import ServiceGeneralForm from "@/form/serviceGeneral/serviceGeneral";

@Component({
  components: {FormGroup},
})
export default class ServiceGeneralFormComponent extends Vue {
  @Prop() readonly form!:  ServiceGeneralForm;

    update(){
        this.$emit("update");
    }

    async created(): Promise<void> {
       console.log('form in detail');
       console.log(this.form.description);
    }

}

